import { Injectable } from "@angular/core";

const LOCAL_STORAGE_TOKEN = 'token';

@Injectable({
    providedIn:'root'
})
export class TokenService{

    salvaToken(token: string) {
        localStorage.setItem(LOCAL_STORAGE_TOKEN, token);
    }

    retornaToken(): string {
       return localStorage.getItem(LOCAL_STORAGE_TOKEN) ?? '';
    }

    removeToken() {
        localStorage.clear();
        localStorage.removeItem(LOCAL_STORAGE_TOKEN)
    }

    hasToken(): boolean {
        return !!this.retornaToken();
    }
}